import React from 'react';
export function FooterSection() {
  return <footer className="bg-black text-white/30 py-10 text-center text-sm px-4 border-t border-brand-border" data-id="element-126">
      <p className="font-medium tracking-wide" data-id="element-127">
        © MEGAPACK FÍSICA Y QUÍMICA LISTA — Todos los derechos reservados
      </p>
    </footer>;
}